export default function compareValues(key: string, order: string | string[] = 'asc') {
  return function(a: { [key: string]: any; }, b: { [key: string]: any; }) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }

    const varA = a[key];
    const varB = b[key];

    let comparison: number = 0;
    if (!Array.isArray(order)) {
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    } else {
      return order.indexOf(varA) - order.indexOf(varB);
    }
  };
}
